import React from 'react';
import { connect } from 'react-redux';
import ACHSWhiteLogo from '../../../images/ACHSWhiteLogo.svg';
import { loginAction } from './actions';

import styles from './Redirection.module.scss';

class Redirection extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(loginAction({
      id: this.props.data.Username,
      contrasenia: this.props.data.Password,
    }));
  };
  
  render() {
    return (
      <div id='redirectionRoot' className={styles.root}>
        <div id='redirectionContainer' className={styles.redirectionContainer}>
          <img
            id='redirectionContainer_ACHSWhiteLogo'
            className={styles.ACHSWhiteLogo}
            src={ACHSWhiteLogo}
            alt='Logo de ACHS Virtual'
          />
          <p id='redirectionContainer_greetingsParagraph' className={styles.greetingsParagraph}>
            ¡Hola{' '}
            <span role='img' aria-label='greeting hand'>
              👋
            </span>
            !
          </p>
          <p id='redirectionContainer_redirectParagraph' className={styles.redirectParagraph}>
            Te estamos redirigiendo a la nueva versión de ACHS Virtual
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.login.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Redirection);
